import get_token from "./get-token";
import update_invoice from "./update-invoice";

export const SUPPLIER_API = {
  get_token: get_token,
  update_invoice: update_invoice,
};
